import { render, staticRenderFns } from "./CondoDetailsPage.vue?vue&type=template&id=20f6ebe2&"
import script from "./CondoDetailsPage.vue?vue&type=script&lang=js&"
export * from "./CondoDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f6ebe2')) {
      api.createRecord('20f6ebe2', component.options)
    } else {
      api.reload('20f6ebe2', component.options)
    }
    module.hot.accept("./CondoDetailsPage.vue?vue&type=template&id=20f6ebe2&", function () {
      api.rerender('20f6ebe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/CondoDetailsPage.vue"
export default component.exports